import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// material-ui components
import { withStyles } from '@material-ui/core/styles';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardActions from '@material-ui/core/CardActions';

import { loginCardStyle } from './styles.jsx';

function LoginCard({ ...props }) {
    const {
        classes,
        headerColor,
        plainCard,
        cardTitle,
        cardSubtitle,
        content,
        footer,
        socials,
        footerAlign,
    } = props;

    const cardPlainHeaderClasses = cx({
        [' ' + classes.cardPlainHeader]: plainCard,
    });
    return (
        <div className='login-tab-content'>
            {cardTitle && <CardHeader
                classes={ {
                    root:
                    classes.cardHeader +
                    ' ' +
                    classes[headerColor + 'CardHeader'] +
                    cardPlainHeaderClasses,
                    title: classes.cardTitle,
                    subheader: classes.cardSubtitle,
                } }
                title={ cardTitle }
            />}

            <CardContent className={ classes.cardContent + ' top-login'}>
                { content }
                <p className={ classes.cardSubtitle }>{ cardSubtitle }</p>
                { socials }
            </CardContent>

            { footer !== undefined ? (
                <CardActions
                    className={ classes.cardActions + ' ' + classes[footerAlign] }
                >
                    { footer }
                </CardActions>
            ) : null }
        </div>
    );
}

LoginCard.defaultProps = {
    headerColor: 'purple',
};

LoginCard.propTypes = {
    plainCard: PropTypes.bool,
    classes: PropTypes.object.isRequired,
    headerColor: PropTypes.oneOf([
        'orange',
        'green',
        'red',
        'blue',
        'purple',
        'rose',
    ]),
    cardTitle: PropTypes.node,
    cardSubtitle: PropTypes.node,
    content: PropTypes.node,
    footer: PropTypes.node,
    socials: PropTypes.node,
    footerAlign: PropTypes.oneOf(['left', 'right', 'center']),
    customCardClass: PropTypes.string,
};

export default withStyles(loginCardStyle)(LoginCard);



// WEBPACK FOOTER //
// ./src/common/Cards/LoginCard.jsx